<div *ngIf="(isValidFund && !isHiddenFundId && !isInvalidFund && isInternalFund) || (nonVanguardFundsViewableFlag && isExternalFund)">
    <dashboard></dashboard>
    <div class="nav-tabs">
        <nav-tab-group [tickerOrFundId]="tickerOrFundId" [barChartSection]="barChartSection"></nav-tab-group>
    </div>
    <div *ngIf="innerWidth>992">
        <overview></overview>
        <performance></performance>
        <price></price>
        <portfolio></portfolio>
        <distributions *ngIf="!isExternalFund"></distributions>
        <fund-management *ngIf="!isExternalFund"></fund-management>
        <fund-literature *ngIf="!is529Fund && !isExternalFund"></fund-literature>
    </div>
    <disclosures></disclosures>
</div>


<div *ngIf= "!isValidFund || isHiddenFundId || isInvalidFund ||  !this.data?.fundProfile || (!nonVanguardFundsViewableFlag && isExternalFund)">
    <vmf-error></vmf-error>
</div>
